var _style, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPl13(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "layer",
    x: 0,
    y: 0,
    style: {
      enableBackground: "new 0 0 652 652"
    },
    viewBox: "0 0 652 652",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st1{fill:#a0a8d4}")), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    x1: 135.788,
    x2: 51.707,
    y1: 437.968,
    y2: 346.818,
    gradientTransform: "matrix(1 0 0 -1 -6 650.25)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    style: {
      stopColor: "#a0a8d4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    style: {
      stopColor: "#8791c7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#6470b4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M53.5 303.4c2.3 4.9 8 14.6 8 14.6L127 209.7l-64 44.6c-3.8 2.5-6.9 6-9.1 10-5.9 12.3-6 26.6-.4 39.1z",
    style: {
      fill: "url(#SVGID_1_)"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 339c1.5 21 11.9 40.3 28.6 53l70.7 49.3s-44.2-63.8-81.6-127.2c-3.8-6.7-6.3-14-7.5-21.6-.5-3.4-.5-6.9 0-10.4-1 1.8-2.9 5.5-2.9 5.5-3.8 7.7-6.4 16-7.6 24.5-.6 8.9-.6 18 .3 26.9z",
    className: "st1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    x1: 137.599,
    x2: 221.692,
    y1: 211.588,
    y2: 302.72,
    gradientTransform: "matrix(1 0 0 -1 -6 650.25)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    style: {
      stopColor: "#a0a8d4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    style: {
      stopColor: "#8791c7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#6470b4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M207.9 347.6c-2.3-4.9-8-14.6-8-14.6l-65.5 108.3 63.9-44.6c3.8-2.5 6.9-6 9.1-10 6-12.4 6.1-26.7.5-39.1z",
    style: {
      fill: "url(#SVGID_2_)"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M233.9 311.9c-1.5-21-11.9-40.3-28.6-53l-70.7-49.3s44.2 63.8 81.6 127.2c3.8 6.7 6.3 14 7.5 21.6.5 3.4.5 6.9 0 10.4 1-1.8 2.9-5.5 2.9-5.5 3.8-7.7 6.4-16 7.6-24.5.6-8.9.6-17.9-.3-26.9z",
    className: "st1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    x1: 136.688,
    x2: 136.688,
    y1: 441.747,
    y2: 208.232,
    gradientTransform: "matrix(1 0 0 -1 -6 650.25)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#513eff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    style: {
      stopColor: "#5157ff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    style: {
      stopColor: "#5298ff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#52e5ff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M53.9 264.3c2.2-4 5.3-7.5 9.1-10l63.9-44.6L61.4 318s-5.7-9.7-8-14.6c-5.6-12.5-5.4-26.8.5-39.1zM27.5 339c1.5 21 11.9 40.3 28.6 53l70.7 49.3s-44.2-63.8-81.6-127.2c-3.8-6.7-6.3-14-7.5-21.6-.5-3.4-.5-6.9 0-10.4-1 1.8-2.9 5.5-2.9 5.5-3.8 7.7-6.4 16-7.6 24.5-.6 8.9-.6 18 .3 26.9zm180.3 8.6c-2.3-4.9-8-14.6-8-14.6l-65.4 108.3 63.9-44.6c3.8-2.5 6.9-6 9.1-10 5.9-12.3 6.1-26.6.4-39.1zm26-35.6c-1.5-21-11.9-40.3-28.6-53l-70.6-49.3s44.2 63.8 81.6 127.2c3.8 6.7 6.3 14 7.5 21.6.5 3.4.5 6.9 0 10.4 1-1.8 2.9-5.5 2.9-5.5 3.8-7.7 6.4-16 7.6-24.5.7-9 .7-18-.2-27l-.2.1z",
    style: {
      fill: "url(#SVGID_3_)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M301.6 386.5V266.7c0-.3.3-.6.6-.6h76.1c.3 0 .6.3.6.6V282c0 .3-.3.6-.6.6H320v35.3h49.7c.3 0 .6.3.6.6v15.1c0 .3-.3.6-.6.6H320v36.4h58.4c.3 0 .6.3.6.6v15.3c0 .3-.3.6-.6.6h-76.1c-.4 0-.7-.2-.7-.6zm189.4.3L435.3 302v84.5c0 .3-.3.6-.6.6h-17.2c-.3 0-.6-.3-.6-.6V266.8c0-.3.3-.6.6-.6h15.9c.2 0 .4.1.5.3l55.8 84.7v-84.3c0-.3.3-.6.6-.6h17.2c.3 0 .6.3.6.6v119.7c0 .3-.3.6-.6.6h-15.9c-.3-.1-.5-.2-.6-.4zm73.3-22.9v5.7c7.4 1.6 14.9 2.5 22.4 2.6 7.4-.2 14.8-1 22.1-2.6v-27.1l-62.3-21.8c-.2-.1-.4-.3-.4-.6v-49.8c0-.3.1-.5.4-.6 13-3.6 26.4-5.6 39.9-5.7 13.5.2 27 2.1 40.1 5.7.3.1.4.3.4.6v18.8c0 .3-.3.6-.6.6h-16.9c-.3 0-.6-.3-.6-.6v-5.7c-7.4-1.6-14.9-2.5-22.4-2.6-7.4.1-14.8 1-22.1 2.6l.1 25.6 62.1 21.7c.2.1.4.3.4.6v51.4c0 .3-.1.5-.4.6-13 3.6-26.4 5.6-39.9 5.7-13.5-.2-27-2.1-40.1-5.7-.3-.1-.4-.3-.4-.6v-18.8c0-.3.3-.6.6-.6h16.8c.3-.1.7.1.8.4v.2z",
    style: {
      fill: "#2b2b2b"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPl13);
export default __webpack_public_path__ + "static/media/pl13.8294535cfc299377c0048eac59f3e41c.svg";
export { ForwardRef as ReactComponent };